import { defineRows, FieldTemplate, TemplateRow } from '../../../app/components/fields-template/field-template';
import type { entityTypes } from '../entitytypes';
import { BASE_ROWS } from './base';

type WipeET = (typeof entityTypes)['wipe'];

export class WipeTemplate implements FieldTemplate {
    rows: TemplateRow[] = defineRows<WipeET>([
        ...BASE_ROWS,
        {
            type: 'row',
            children: [
                {
                    type: 'field',
                    fieldKey: 'verkeersmaatregel',
                    fieldGroup: 'planningData',
                    classes: 'col-24 col-md',
                },
                { type: 'field', fieldKey: 'person_id', fieldGroup: 'planningData', classes: 'col-24 col-md' },
                { type: 'field', fieldKey: 'contacttelefoon', fieldGroup: 'planningData', classes: 'col-24 col-md' },
                { type: 'field', fieldKey: 'behoefteUren', fieldGroup: 'pheData', classes: 'col-24 col-md' },
            ],
        },
    ]);
}
